module.exports = "img/videos/2.1cb0e8.mp4";